import { deepmerge } from '@mui/utils';
import { spacing as spacingMap } from './figmaVariables';
import { pxW, pxH } from './designViewportUnits';

/**
 * MUI spacing: 피그마 spacing 맵의 px를 360 기준 vw로 변환
 */
export function userViewportSpacing(factor) {
    const mapped = spacingMap[factor];
    if (typeof mapped === 'string' && mapped.endsWith('px')) {
        const num = parseFloat(mapped);
        return pxW(num);
    }
    const f = Number(factor);
    if (!Number.isFinite(f)) {
        return `${factor}px`;
    }
    return pxW(f * 4);
}

/**
 * 유저 앱(appType === 'user')용: rem(루트 font-size) + spacing/button 등 vw/vh 반응형
 */
export function mergeUserViewportTheme(baseTheme) {
    return deepmerge(baseTheme, {
        spacing: userViewportSpacing,
        shape: {
            borderRadius: pxW(4),
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: pxW(6),
                    },
                    sizeSmall: {
                        height: pxW(32),
                        minHeight: pxW(32),
                        padding: `${pxH(8)} ${pxW(16)}`,
                    },
                    sizeMedium: {
                        height: pxW(40),
                        minHeight: pxW(40),
                        padding: `${pxH(12)} ${pxW(24)}`,
                    },
                    sizeLarge: {
                        height: pxW(48),
                        minHeight: pxW(48),
                        padding: `${pxH(16)} ${pxW(32)}`,
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        '& .MuiOutlinedInput-root': {
                            borderRadius: pxW(6),
                        },
                    },
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        borderRadius: pxW(6),
                    },
                    input: {
                        padding: `${pxH(12)} ${pxW(14)}`,
                    },
                    inputSizeSmall: {
                        padding: `${pxH(8)} ${pxW(12)}`,
                    },
                },
            },
            MuiCard: {
                styleOverrides: {
                    root: {
                        borderRadius: pxW(8),
                    },
                },
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        padding: pxW(8),
                    },
                    sizeSmall: {
                        padding: pxW(4),
                    },
                    sizeLarge: {
                        padding: pxW(12),
                    },
                },
            },
            MuiDialog: {
                styleOverrides: {
                    paper: {
                        borderRadius: pxW(12),
                        margin: pxW(16),
                    },
                },
            },
            MuiChip: {
                styleOverrides: {
                    root: {
                        borderRadius: pxW(8),
                    },
                },
            },
        },
    });
}
